import React, { useEffect, useState } from "react";
import axios from "axios";

import PageHeader from "../components/ui/PageHeader";
import Card from "../components/ui/Card";
import DataTable from "../components/ui/DataTable";
import useAuth from "../hooks/useAuth";
import { useSeason } from "../context/SeasonContext";
import { FiRefreshCw } from "react-icons/fi";

const API = "https://maize.norissolutions.in/Php/public/api";

const COLUMNS = [
  {
    key: "entry_date",
    label: "Date",
    render: (v) => (
      <span style={{ fontFamily: "var(--font-mono)", fontSize: 11 }}>
        {v}
      </span>
    ),
  },

  {
    key: "description",
    label: "Description",
    render: (v) => <span style={{ color: "var(--text)" }}>{v}</span>,
  },

  {
    key: "debit",
    label: "Debit (₹)",
    render: (v) => (
      <span
        style={{
          fontFamily: "var(--font-mono)",
          color: v && v !== "0.00" ? "var(--red)" : "var(--text-dim)",
        }}
      >
        {v && v !== "0.00" ? v : "–"}
      </span>
    ),
  },

  {
    key: "credit",
    label: "Credit (₹)",
    render: (v) => (
      <span
        style={{
          fontFamily: "var(--font-mono)",
          color: v && v !== "0.00" ? "var(--accent)" : "var(--text-dim)",
        }}
      >
        {v && v !== "0.00" ? v : "–"}
      </span>
    ),
  },
];

export default function Ledger() {
  const token = sessionStorage.getItem("maaze_token");
  const { refreshToken } = useAuth();
  const { seasons, selectedSeason } = useSeason() || {};
  const seasonName = seasons?.find(s => s.season_id.toString() === selectedSeason?.toString())?.season_name || "Active Season";

  const [ledger, setLedger] = useState([]);

  /* ================= FETCH LEDGER ================= */

  const fetchLedger = async () => {
    const res = await axios.get(`${API}/finance/generalledger`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setLedger(res.data?.data || res.data || []);
  };

  useEffect(() => {
    fetchLedger();
  }, []);

  return (
    <div>
      <PageHeader
        title="Ledger"
        subtitle="General ledger – all financial entries"
      >
        <FiRefreshCw className="page-refresh" onClick={refreshToken} />
      </PageHeader>

      <Card title="General Ledger" subtitle={`Season ${seasonName}`} noPad>
        <DataTable columns={COLUMNS} rows={ledger} />
      </Card>
    </div>
  );
}